<template>
  <base-wrapper>
    <div class="space-y-4">
      <alert-message
        v-if="!botRunning"
        type="error"
        message="Tidak dapat terhubung dengan server"
      />

      <datatable
        v-else
        :columns="[
          { id: 'id', name: 'ID Device' },
          { id: 'contact', name: 'Kontak' },
          { id: 'qr', name: 'QR' },
          { id: 'status', name: 'Status', theadClass: 'text-center' },
          { id: 'action', name: 'Aksi', theadClass: 'text-center' },
        ]"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="device in devices"
            :key="device.device_id"
            :class="[classes.tr, 'bg-white']"
          >
            <td :class="classes.td">{{ device.device_id }}</td>
            <td :class="classes.td">
              <p class="font-bold text-gray-900">{{ device.name }}</p>
              <p>{{ device.phone_number }}</p>
            </td>
            <td :class="classes.td">
              <qr-code
                v-if="!device.connected && device.qr"
                :text="device.qr"
              />
            </td>
            <td :class="[classes.td, 'text-center']">
              <base-badge :color="device.connected ? 'green' : 'yellow'">{{
                device.connected ? 'Terhubung' : 'Belum Terhubung'
              }}</base-badge>
            </td>
            <td :class="[classes.td, 'text-center']">
              <button
                v-if="device.connected"
                title="Hapus device ini"
                @click="onLogout(device)"
              >
                <Icon icon="heroicons:x-mark" class="h-5 w-5 text-red-600" />
              </button>
            </td>
          </tr>
        </template>
      </datatable>
    </div>
    <loading v-if="loading" />
  </base-wrapper>
</template>

<script>
import { requestMixin } from '../../../../mixins/request/request';
import AlertMessage from '../../../../components/base/AlertMessage.vue';
import QrCode from 'vue-qrcode-component';

export default {
  mixins: [requestMixin],
  components: { AlertMessage, QrCode },
  data() {
    return {
      devices: [],
      loadingDevices: true,
      loadingBotStatus: true,
      botRunning: false,
    };
  },
  computed: {
    loading() {
      return this.loadingDevices || this.loadingBotStatus;
    },
  },
  methods: {
    async checkBotStatus() {
      this.loadingBotStatus = true;

      const [res, err] = await this.request(`/api/v1/whatsapp-bot/status`);

      if (!err) {
        this.botRunning = res.running;
      }

      this.loadingBotStatus = false;
    },
    async getDevices() {
      this.loadingDevices = true;

      const [res, err] = await this.request(`/api/v1/whatsapp-bot/devices`);

      if (!err) {
        this.devices = res;
      }

      this.loadingDevices = false;
    },
    listenToQr() {
      const channel = this.$pusher.subscribe('private-WhatsappBot');

      channel.bind('App\\Events\\WhatsappBotQrGenerated', (e) => {
        this.onQrGenerated(e.device_id, e.qr);
      });
      channel.bind('App\\Events\\WhatsappBotDeviceConnectionUpdated', (e) => {
        this.onDeviceConnectionUpdated({
          deviceId: e.device_id,
          connected: e.connected,
          name: e.name,
          phoneNumber: e.phone_number,
        });
      });
      channel.bind('App\\Events\\WhatsappBotStatusUpdated', (e) => {
        this.onBotStatusUpdated(e.running);
      });
    },
    async onLogout(removedDevice) {
      this.loadingDevices = true;

      await this.request(`/api/v1/whatsapp-bot/logout`, {
        method: 'post',
        data: {
          device_id: removedDevice.device_id,
        },
      });

      this.devices = this.devices.filter(
        (device) => device.device_id !== removedDevice.device_id
      );

      this.loadingDevices = false;
    },
    onApplyQrGenerated(deviceId, qr) {
      this.devices = this.devices.map((device) => {
        if (device.device_id !== deviceId) {
          return device;
        }

        return {
          device_id: deviceId,
          connected: false,
          name: null,
          phone_number: null,
          qr,
        };
      });
    },
    onQrGenerated(deviceId, qr) {
      if (this.devices.some((device) => device.device_id === deviceId)) {
        this.devices = this.devices.map((device) => {
          if (device.device_id !== deviceId) {
            return device;
          }

          return {
            device_id: deviceId,
            connected: false,
            name: null,
            phone_number: null,
            qr: null,
          };
        });

        setTimeout(() => this.onApplyQrGenerated(deviceId, qr), 1000);
      } else {
        this.devices.push({
          device_id: deviceId,
          connected: false,
          name: null,
          phone_number: null,
          qr,
        });
      }
    },
    onDeviceConnectionUpdated({ deviceId, connected, name, phoneNumber }) {
      if (this.devices.some((device) => device.device_id === deviceId)) {
        this.devices = this.devices.map((device) => {
          if (device.device_id !== deviceId) {
            return device;
          }

          return {
            device_id: deviceId,
            qr: null,
            phone_number: phoneNumber,
            name,
            connected,
          };
        });
      } else {
        this.devices.push({
          device_id: deviceId,
          qr: null,
          phone_number: phoneNumber,
          name,
          connected,
        });
      }
    },
    onBotStatusUpdated(running) {
      this.botRunning = running;
    },
    stopListenToQr() {
      this.$pusher.unsubscribe('private-WhatsappBot');
    },
  },
  created() {
    this.checkBotStatus();
    this.getDevices();
    this.listenToQr();
  },
  destroyed() {
    this.stopListenToQr();
  },
};
</script>
